module.exports = {
      id: "search-white-usage",
      viewBox: "0 0 20 20.051",
      url: "/" + "sprite-f96a299a5e63739e5b36582e48c149a3.svg#search-white",
      toString: function () {
        return this.url;
      }
    }